var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gz-filter-container"},[_vm._t("filters"),_c('div',{staticClass:"gz-filters__data"},[_vm._t("data")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }